module.exports = __webpack_public_path__ + "0894d133eea535d1e98eec8ff2f11d5d.svg";